import { useEffect, useRef } from 'react'
import { motion, useMotionValue, useTransform, animate } from 'framer-motion'

const CountMotion = ({ number, duration }) => {
  const ref = useRef()
  const count = useMotionValue(0)
  const rounded = useTransform(count, Math.round)

  useEffect(() => {
    const animation = animate(count, number, { duration: duration })

    return animation.stop
  }, [count, duration, number])

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      viewport={{ once: true, amount: 0.9 }}
    >
      {rounded}
    </motion.div>
  )
}

export default CountMotion
